export function useNumberFormatter(value: number): string {
    if (value >= 1_000_000) {
        const result = value / 1_000_000
        return `${Number.isInteger(result) ? result : result.toFixed(1)}M`
    }

    if (value >= 1_000) {
        const result = value / 1_000
        return `${Number.isInteger(result) ? result : result.toFixed(1)}K`
    }

    return value.toString()
}
